import React, { useRef } from "react";
import { useDispatch } from "react-redux";
import { MagicResearchStep } from "../../../../lib/types";
import { openTooltip } from "../../../../store/actions";

interface IProps {
  govId?: number;
  researchLevel: number;
  nextLevelAvailable: boolean;
  step: MagicResearchStep;
}

const MagicResearchStepIcon = ({
  govId,
  researchLevel,
  nextLevelAvailable,
  step
}: IProps) => {
  const iconRef = useRef<HTMLAnchorElement>(null);

  const dispatch = useDispatch();

  return (
    <li
      className={`step ${researchLevel >= step.id ? "active" : ""}
                ${researchLevel === step.id - 1 && nextLevelAvailable
        ? "available"
        : ""}`}
      style={{ transform: "rotate(-90deg)", marginRight: "15px" }}
    >
      <a
        ref={iconRef}
        onClick={() => dispatch(openTooltip({
          name: "MagicResearchStepInfo",
          dynamic: true,
          classes: ["rich-tooltip", "text-center"],
          step,
          active: researchLevel >= step.id,
          available: (researchLevel === step.id - 1
            && nextLevelAvailable),
          govId,
          elementRef: iconRef
        }))}
        style={{ transform: "rotate(90deg)" }}
        tabIndex={0}
      >
        {step.id}
      </a>
    </li>
  )
}

export default MagicResearchStepIcon;
